function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.3822 274.179C74.6047 274.771 87.8272 275.066 101.05 275.039C101.56 275.039 101.56 274.233 101.05 274.233C87.8272 274.26 74.6047 273.964 61.3822 273.373C60.8716 273.346 60.8716 274.153 61.3822 274.179Z",
  fill: "#E1E1E1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M101.856 254.185C103.925 261.952 105.86 269.773 107.634 277.62C107.742 278.131 108.521 277.916 108.413 277.405C106.613 269.558 104.705 261.737 102.635 253.97C102.501 253.487 101.722 253.702 101.856 254.185Z",
  fill: "#E1E1E1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M137.869 254.776C137.116 262.166 136.364 269.584 135.638 276.974C135.584 277.485 136.391 277.485 136.444 276.974C137.197 269.584 137.949 262.166 138.675 254.776C138.702 254.265 137.896 254.265 137.869 254.776Z",
  fill: "#E1E1E1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M107.85 278.345C112.553 279.178 117.31 279.554 122.093 279.42C126.662 279.285 131.661 278.936 136.015 277.485C136.498 277.324 136.283 276.544 135.8 276.705C131.473 278.13 126.608 278.479 122.093 278.614C117.39 278.748 112.687 278.372 108.065 277.565C107.554 277.458 107.339 278.237 107.85 278.345Z",
  fill: "#E1E1E1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M102.178 254.453C107.742 256.012 113.788 256.039 119.54 256.066C125.721 256.119 131.902 255.77 138.03 255.071C138.54 255.017 138.54 254.211 138.03 254.265C132.063 254.964 126.07 255.286 120.077 255.259C114.245 255.232 108.064 255.232 102.393 253.674C101.883 253.539 101.668 254.319 102.178 254.453Z",
  fill: "#E1E1E1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8677 251.685C99.9214 252.196 99.9752 252.733 100.029 253.244C100.056 253.566 100.056 253.969 100.19 254.265C100.513 254.964 101.588 254.722 102.206 254.722C102.716 254.722 102.716 253.916 102.206 253.916C101.91 253.916 101.615 253.916 101.292 253.916C100.889 253.916 100.889 253.835 100.862 253.432C100.808 252.841 100.755 252.276 100.701 251.685C100.62 251.174 99.8139 251.148 99.8677 251.685Z",
  fill: "#E1E1E1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M100.405 252.115C107.123 252.894 113.869 253.271 120.642 253.324C123.974 253.351 127.307 253.297 130.666 253.19C132.332 253.136 133.998 253.056 135.665 252.975C136.444 252.948 137.519 252.679 138.298 252.841C139.239 253.002 139.185 253.808 139.293 254.641C139.373 254.48 139.481 254.319 139.562 254.157C139.212 254.157 138.863 254.157 138.513 254.157C138.003 254.05 137.788 254.829 138.298 254.937C138.836 255.044 139.239 255.044 139.75 254.937C139.992 254.883 140.072 254.641 140.018 254.453C139.884 253.512 139.992 252.33 138.863 252.088C138.191 251.927 137.358 252.115 136.659 252.142C135.772 252.196 134.912 252.222 134.025 252.276C130.263 252.437 126.473 252.545 122.684 252.545C115.213 252.545 107.768 252.196 100.351 251.309C99.8941 251.255 99.8941 252.061 100.405 252.115Z",
  fill: "#E1E1E1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M106.237 271.653C108.387 274.475 110.913 276.92 113.762 279.017C114.192 279.312 114.595 278.614 114.165 278.318C111.424 276.302 108.978 273.937 106.909 271.223C106.613 270.82 105.914 271.223 106.237 271.653Z",
  fill: "#E1E1E1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M104.436 263.456C108.629 269.503 113.789 274.797 119.755 279.124C120.185 279.42 120.588 278.721 120.158 278.425C114.326 274.179 109.247 268.965 105.135 263.053C104.839 262.623 104.14 263.026 104.436 263.456Z",
  fill: "#E1E1E1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M102.797 256.254C110.053 264.854 118.116 272.889 127.737 278.856C128.167 279.124 128.597 278.426 128.14 278.157C118.573 272.244 110.564 264.262 103.361 255.689C103.039 255.286 102.474 255.877 102.797 256.254Z",
  fill: "#E1E1E1"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M110.51 255.797C117.417 263.832 125.076 271.465 133.622 277.754C134.052 278.049 134.455 277.351 134.025 277.055C125.533 270.82 117.927 263.187 111.074 255.232C110.725 254.829 110.16 255.394 110.51 255.797Z",
  fill: "#E1E1E1"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M119.325 256.361C124.001 262.086 129.376 267.192 135.343 271.573C135.773 271.868 136.176 271.169 135.746 270.874C129.833 266.547 124.512 261.468 119.889 255.797C119.567 255.394 119.003 255.958 119.325 256.361Z",
  fill: "#E1E1E1"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M126.527 256.067C129.537 259.453 132.977 262.356 136.793 264.801C137.223 265.07 137.626 264.371 137.196 264.102C133.434 261.711 130.047 258.808 127.091 255.502C126.742 255.099 126.177 255.664 126.527 256.067Z",
  fill: "#E1E1E1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M89.3323 211.775C91.0792 215.457 92.2617 219.327 92.9336 223.358C92.9605 223.547 93.1486 223.654 93.3098 223.654C93.4711 223.654 94.3311 223.627 94.3848 223.896C94.4117 224.003 93.8742 224.622 93.8205 224.756C93.6592 225.186 93.6592 225.697 93.8205 226.127C94.0355 226.637 94.4386 226.987 94.9223 227.175C95.0836 227.255 95.2717 227.282 95.4598 227.309C95.6211 227.336 95.7823 227.336 95.9436 227.309C96.1586 227.282 96.1317 227.309 95.8898 227.417C95.6211 227.82 95.2448 227.873 95.1373 228.465C95.0567 229.029 95.3255 229.567 95.5405 230.05C96.4273 231.932 96.938 233.92 97.6636 235.882C100.163 242.547 104.947 248.057 110.349 252.598C110.752 252.921 111.316 252.357 110.913 252.034C105.35 247.358 100.405 241.633 98.0667 234.619C97.7711 233.705 97.5023 232.792 97.1798 231.905C96.9111 231.125 96.4005 230.319 96.1586 229.54C95.8898 229.11 95.9167 228.626 96.2661 228.142C96.3736 228.062 96.4811 227.981 96.5886 227.9C96.6692 227.766 96.8305 227.685 96.9111 227.524C97.0186 227.228 96.938 226.96 96.723 226.745C96.3736 226.395 95.8361 226.583 95.3792 226.449C93.6323 225.938 95.0567 224.756 95.1911 223.896C95.3792 222.767 93.9817 222.902 93.2292 222.848C93.3636 222.955 93.498 223.036 93.6055 223.143C92.9336 219.058 91.6973 215.108 89.9236 211.372C89.8161 210.888 89.1173 211.292 89.3323 211.775Z",
  fill: "#E1E1E1"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M89.6279 211.587C98.3623 213.925 106.022 219.865 111.585 226.906C117.497 234.377 121.179 243.354 123.168 252.625C123.275 253.136 124.055 252.921 123.947 252.41C121.932 243.004 118.169 233.92 112.176 226.342C106.532 219.22 98.7386 213.2 89.8698 210.835C89.3323 210.674 89.1173 211.453 89.6279 211.587Z",
  fill: "#E1E1E1"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M92.7995 214.92C103.496 225.321 111.746 238.086 116.826 252.142C117.014 252.626 117.793 252.411 117.605 251.927C112.472 237.764 104.168 224.864 93.3639 214.356C93.0145 213.979 92.4233 214.544 92.7995 214.92Z",
  fill: "#E1E1E1"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M97.5562 231.824C99.8137 232.066 102.017 232.577 104.114 233.41C106.156 234.216 108.387 235.238 109.677 237.092C109.972 237.522 110.671 237.119 110.376 236.689C109.086 234.834 107.07 233.786 105.027 232.926C102.636 231.905 100.136 231.287 97.5293 231.018C97.0456 230.964 97.0456 231.771 97.5562 231.824Z",
  fill: "#E1E1E1"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M101.561 217.096C101.534 220.187 102.044 223.224 103.039 226.153C103.2 226.637 103.979 226.422 103.818 225.938C102.851 223.089 102.367 220.133 102.367 217.096C102.367 216.586 101.561 216.586 101.561 217.096Z",
  fill: "#E1E1E1"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M116.315 231.717C117.632 226.799 122.013 223.869 125.748 220.859C129.726 217.661 133.569 214.248 137.224 210.7C137.009 210.566 136.767 210.432 136.552 210.297C135.343 213.549 135.101 216.962 135.155 220.402C135.208 223.842 135.988 227.793 134.886 231.125C135.02 231.018 135.155 230.937 135.262 230.83C134.402 230.884 133.542 230.964 132.682 231.018C132.413 231.045 132.145 231.367 132.333 231.636C132.951 232.469 133.677 232.738 133.65 233.974C133.65 234.834 133.435 235.829 133.139 236.635C132.843 237.468 132.064 238.032 131.795 238.812C131.58 239.51 132.118 240.102 132.118 240.8C132.145 241.956 131.312 242.924 130.72 243.837C130.156 244.697 129.645 245.584 129.188 246.498C128.275 248.299 127.549 250.153 127.012 252.088C126.877 252.599 127.657 252.814 127.791 252.303C128.463 249.911 129.43 247.6 130.693 245.45C131.553 243.999 133.166 242.305 132.978 240.478C132.897 239.752 132.521 239.537 132.843 238.704C132.87 238.677 133.354 238.032 133.381 237.979C133.892 237.145 134.133 236.205 134.295 235.264C134.402 234.566 134.617 233.705 134.51 233.007C134.348 232.012 133.596 231.932 133.032 231.179C132.924 231.394 132.79 231.582 132.682 231.797C133.542 231.744 134.402 231.663 135.262 231.609C135.45 231.582 135.585 231.502 135.638 231.314C136.66 228.196 136.042 224.568 135.934 221.343C135.827 217.661 135.961 213.952 137.278 210.459C137.439 210.055 136.875 209.814 136.606 210.055C132.709 213.845 128.624 217.473 124.351 220.859C120.696 223.762 116.745 226.718 115.482 231.448C115.402 232.012 116.181 232.227 116.315 231.717Z",
  fill: "#E1E1E1"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M134.241 214.195C131.607 218.79 128.919 223.332 126.393 227.982C124.028 232.282 121.932 236.743 120.938 241.553C120.83 242.064 121.609 242.279 121.717 241.768C122.738 236.85 124.915 232.335 127.334 227.955C129.806 223.467 132.413 219.059 134.939 214.598C135.181 214.168 134.483 213.738 134.241 214.195Z",
  fill: "#E1E1E1"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M126.312 221.666C126.662 223.198 126.823 224.729 126.769 226.288C126.742 226.799 127.549 226.799 127.575 226.288C127.629 224.649 127.468 223.063 127.092 221.451C126.957 220.94 126.205 221.155 126.312 221.666Z",
  fill: "#E1E1E1"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M130.693 216.533C130.989 217.688 131.042 218.817 130.908 219.973C130.854 220.483 131.661 220.483 131.714 219.973C131.876 218.736 131.795 217.527 131.472 216.318C131.338 215.834 130.559 216.049 130.693 216.533Z",
  fill: "#E1E1E1"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M130.881 221.881C132.467 220.94 134.106 220.107 135.799 219.408C136.283 219.22 136.068 218.441 135.584 218.629C133.811 219.354 132.117 220.214 130.451 221.182C130.021 221.451 130.424 222.149 130.881 221.881Z",
  fill: "#E1E1E1"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M123.947 235.372C124.969 234.512 125.99 233.679 127.038 232.872C128.14 232.012 129.349 230.857 130.693 230.319C131.177 230.131 130.962 229.352 130.478 229.54C129.269 229.997 128.274 230.884 127.253 231.69C125.936 232.711 124.646 233.732 123.383 234.807C122.98 235.13 123.544 235.694 123.947 235.372Z",
  fill: "#E1E1E1"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M92.826 220.295C94.7072 220.483 96.5885 220.671 98.4697 220.833C98.9803 220.886 98.9803 220.08 98.4697 220.026C96.5885 219.838 94.7072 219.65 92.826 219.489C92.3153 219.435 92.3153 220.241 92.826 220.295Z",
  fill: "#E1E1E1"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M142.142 273.911C175.816 273.911 209.464 273.911 243.138 273.911C252.625 273.911 262.112 273.911 271.599 273.911C272.109 273.911 272.109 273.104 271.599 273.104C237.924 273.104 204.277 273.104 170.602 273.104C161.116 273.104 151.629 273.104 142.142 273.104C141.604 273.104 141.604 273.911 142.142 273.911Z",
  fill: "#E1E1E1"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M256.038 208.067C256.038 211.99 256.038 215.914 256.038 219.838C256.038 220.348 256.845 220.348 256.845 219.838C256.845 215.914 256.845 211.99 256.845 208.067C256.845 207.556 256.038 207.556 256.038 208.067Z",
  fill: "#E1E1E1"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M237.494 221.639C250.529 221.639 263.563 221.639 276.598 221.639C277.108 221.639 277.108 220.833 276.598 220.833C263.563 220.833 250.529 220.833 237.494 220.833C236.984 220.833 236.957 221.639 237.494 221.639Z",
  fill: "#E1E1E1"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M246.256 221.853C246.256 225.24 246.256 228.626 246.256 232.039C246.256 232.55 247.062 232.55 247.062 232.039C247.062 228.653 247.062 225.266 247.062 221.853C247.062 221.316 246.256 221.316 246.256 221.853Z",
  fill: "#E1E1E1"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M266.412 221.638C266.412 224.621 266.412 227.631 266.412 230.615C266.412 231.125 267.218 231.125 267.218 230.615C267.218 227.631 267.218 224.621 267.218 221.638C267.218 221.128 266.412 221.128 266.412 221.638Z",
  fill: "#E1E1E1"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M253.646 232.818C263.617 232.818 273.587 232.818 283.558 232.818C284.069 232.818 284.069 232.012 283.558 232.012C273.587 232.012 263.617 232.012 253.646 232.012C253.136 232.012 253.136 232.818 253.646 232.818Z",
  fill: "#E1E1E1"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M231.098 281.704C253.108 281.704 275.119 281.704 297.13 281.704C297.64 281.704 297.64 280.898 297.13 280.898C275.119 280.898 253.108 280.898 231.098 280.898C230.587 280.898 230.587 281.704 231.098 281.704Z",
  fill: "#E1E1E1"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M322.123 274.743C343.73 274.743 365.365 274.743 386.972 274.743C393.046 274.743 399.12 274.743 405.193 274.743C405.704 274.743 405.704 273.937 405.193 273.937C383.586 273.937 361.951 273.937 340.344 273.937C334.27 273.937 328.196 273.937 322.123 273.937C321.612 273.937 321.612 274.743 322.123 274.743Z",
  fill: "#E1E1E1"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M54.2068 288.504C76.3518 288.504 98.5237 288.504 120.669 288.504C121.179 288.504 121.179 287.697 120.669 287.697C98.5237 287.697 76.3518 287.697 54.2068 287.697C53.6962 287.697 53.6962 288.504 54.2068 288.504Z",
  fill: "#E1E1E1"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M98.8731 296.566C116.96 296.566 135.047 296.566 153.134 296.566C153.644 296.566 153.644 295.76 153.134 295.76C135.047 295.76 116.96 295.76 98.8731 295.76C98.3356 295.76 98.3356 296.566 98.8731 296.566Z",
  fill: "#E1E1E1"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M373.831 66.785C373.831 59.2869 373.831 51.8157 373.831 44.3175C373.831 43.8069 373.025 43.8069 373.025 44.3175C373.025 51.8157 373.025 59.2869 373.025 66.785C373.025 67.2957 373.831 67.2957 373.831 66.785Z",
  fill: "#E1E1E1"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M373.697 44.1563C383.399 44.1563 393.101 44.1563 402.803 44.1563C403.313 44.1563 403.313 43.3501 402.803 43.3501C393.101 43.3501 383.399 43.3501 373.697 43.3501C373.186 43.3501 373.186 44.1563 373.697 44.1563Z",
  fill: "#E1E1E1"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M402.399 43.8068C402.345 51.4124 402.292 59.018 402.211 66.6237C402.211 67.1343 403.017 67.1343 403.017 66.6237C403.071 59.018 403.125 51.4124 403.205 43.8068C403.205 43.2962 402.399 43.2962 402.399 43.8068Z",
  fill: "#E1E1E1"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M373.831 67.1876C383.399 67.1876 392.966 67.1876 402.534 67.1876C403.045 67.1876 403.045 66.3813 402.534 66.3813C392.966 66.3813 383.399 66.3813 373.831 66.3813C373.321 66.3813 373.321 67.1876 373.831 67.1876Z",
  fill: "#E1E1E1"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M374.611 45.8761C374.611 52.1918 374.611 58.4805 374.611 64.7961C374.611 65.3068 375.417 65.3068 375.417 64.7961C375.417 58.4805 375.417 52.1918 375.417 45.8761C375.417 45.3655 374.611 45.3655 374.611 45.8761Z",
  fill: "#E1E1E1"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M375.202 46.2794C383.694 46.2794 392.16 46.2794 400.652 46.2794C401.163 46.2794 401.163 45.4731 400.652 45.4731C392.16 45.4731 383.694 45.4731 375.202 45.4731C374.664 45.4731 374.664 46.2794 375.202 46.2794Z",
  fill: "#E1E1E1"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M400.222 46.0646C400.196 52.2459 400.169 58.4271 400.142 64.6352C400.142 65.1459 400.948 65.1459 400.948 64.6352C400.975 58.454 401.002 52.2727 401.029 46.0646C401.029 45.554 400.222 45.554 400.222 46.0646Z",
  fill: "#E1E1E1"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M375.363 65.3067C383.721 65.3067 392.079 65.3067 400.437 65.3067C400.948 65.3067 400.948 64.5005 400.437 64.5005C392.079 64.5005 383.721 64.5005 375.363 64.5005C374.852 64.5005 374.852 65.3067 375.363 65.3067Z",
  fill: "#E1E1E1"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M375.202 59.7435C378.292 58.6685 381.544 59.636 384.554 60.5229C387.618 61.4098 390.628 62.4848 393.557 63.721C394.041 63.9091 394.256 63.1298 393.772 62.9416C390.52 61.571 387.188 60.4154 383.802 59.4748C380.926 58.6954 377.889 57.9429 374.987 58.9641C374.503 59.1254 374.718 59.9048 375.202 59.7435Z",
  fill: "#E1E1E1"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M385.414 60.6571C390.493 60.3615 395.25 58.319 400.276 57.7546C400.787 57.7009 400.787 56.8946 400.276 56.9484C395.25 57.5127 390.493 59.5284 385.414 59.8509C384.877 59.9046 384.877 60.7109 385.414 60.6571Z",
  fill: "#E1E1E1"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M395.034 50.8211C393.906 50.1761 394.927 48.053 396.136 48.5636C396.781 48.8324 396.916 49.6118 396.566 50.1761C396.19 50.7943 395.411 50.9018 394.766 50.7136C394.255 50.5793 394.04 51.3586 394.551 51.493C395.626 51.7886 396.835 51.4661 397.373 50.418C397.856 49.4774 397.48 48.2411 396.459 47.8111C394.363 46.9243 392.643 50.418 394.631 51.5199C395.061 51.7618 395.491 51.063 395.034 50.8211Z",
  fill: "#E1E1E1"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M386.811 43.6187C386.838 43.1619 386.865 42.705 386.999 42.275C387.106 41.9256 387.375 41.0925 387.778 40.9312C388.504 40.6625 388.773 43.2156 388.826 43.6994C388.88 44.21 389.686 44.21 389.633 43.6994C389.552 42.7587 389.337 39.8025 387.832 40.0175C387.187 40.0981 386.73 40.8237 386.488 41.3612C386.166 42.06 386.058 42.8394 386.031 43.5919C386.005 44.1294 386.811 44.1294 386.811 43.6187Z",
  fill: "#E1E1E1"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M391.327 168.99C391.327 172.215 391.327 175.467 391.327 178.692C391.327 179.203 392.133 179.203 392.133 178.692C392.133 175.467 392.133 172.215 392.133 168.99C392.133 168.48 391.327 168.48 391.327 168.99Z",
  fill: "#E1E1E1"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M381.57 179.875C388.88 179.875 396.217 179.875 403.527 179.875C404.037 179.875 404.037 179.068 403.527 179.068C396.217 179.068 388.88 179.068 381.57 179.068C381.059 179.068 381.059 179.875 381.57 179.875Z",
  fill: "#E1E1E1"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M384.662 180.117C384.662 181.649 384.662 183.154 384.662 184.686C384.662 185.196 385.468 185.196 385.468 184.686C385.468 183.154 385.468 181.649 385.468 180.117C385.468 179.606 384.662 179.606 384.662 180.117Z",
  fill: "#E1E1E1"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M396.406 180.359C396.406 182.159 396.406 183.987 396.406 185.787C396.406 186.298 397.212 186.298 397.212 185.787C397.212 183.987 397.212 182.159 397.212 180.359C397.212 179.821 396.406 179.821 396.406 180.359Z",
  fill: "#E1E1E1"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M390.709 186.836C395.788 186.836 400.867 186.836 405.947 186.836C406.457 186.836 406.457 186.029 405.947 186.029C400.867 186.029 395.788 186.029 390.709 186.029C390.198 186.029 390.198 186.836 390.709 186.836Z",
  fill: "#E1E1E1"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M204.761 265.417C213.226 259.692 217.472 256.817 218.574 256.467C221.262 255.607 229.969 252.839 237.575 257.488C243.031 260.821 248.056 268.05 245.96 272.888C244.455 276.328 239.859 277.403 235.694 278.397C229.539 279.848 224.272 279.042 221.316 278.343C220.16 279.472 218.306 280.977 215.699 281.972C211.372 283.638 206.373 283.342 206.131 282.348C206.024 281.837 207.099 280.843 212.312 278.8C211.694 278.128 210.781 277.322 209.491 276.758C205.674 275.011 201.858 276.704 201.132 277.053C204.868 279.23 205.674 280.359 205.486 280.977C205.002 282.536 197.397 283.047 195.354 279.472C195.139 279.123 194.548 277.913 195.032 275.629C195.999 271.437 199.493 268.991 204.761 265.417Z",
  fill: "#090707"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M241.633 271.383C242.493 269.609 246.363 270.039 247.868 270.2C249.803 270.415 251.523 270.603 253.082 271.974C254.264 272.995 255.984 275.226 255.366 277.027C254.802 278.747 252.678 278.612 248.567 280.628C247.868 280.977 241.149 284.283 241.606 286.46C241.794 287.347 243.003 287.32 246.847 288.959C250.179 290.357 252.141 291.217 253.78 293.098C254.587 294.038 256.199 295.893 255.769 297.774C254.963 301.241 247.76 301.832 247.572 301.295C247.411 300.838 252.463 299.575 252.517 297.21C252.571 295.409 249.749 293.958 247.975 293.017C242.762 290.303 239.241 291.27 237.87 288.663C237.091 287.185 237.521 285.6 237.602 285.304C238.005 283.853 239.133 282.617 244.643 279.848C249.668 277.322 251.899 276.731 251.872 275.602C251.845 274.554 249.91 273.694 248.728 273.398C245.395 272.512 242.95 274.608 241.821 273.425C241.337 272.888 241.364 271.974 241.633 271.383Z",
  fill: "#090707"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M195.73 258.375C197.423 259.638 199.117 260.901 200.81 262.164C203.228 261.922 205.62 261.707 208.039 261.466C209.544 260.014 211.049 258.536 212.554 257.085C212.662 257.999 212.877 260.068 212.957 261.062C213.898 270.012 213.978 270.791 213.414 271.812C211.56 275.118 205.298 276.462 201.697 274.151C199.95 273.022 199.278 271.329 198.015 268.077C196.483 264.153 195.945 260.713 195.73 258.375Z",
  fill: "#090707"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M202.558 267.673C202.155 268.506 201.268 269.017 200.355 268.856C200.113 268.802 200.005 269.205 200.247 269.232C201.349 269.42 202.451 268.883 202.908 267.861C203.015 267.646 202.693 267.431 202.558 267.673Z",
  fill: "white"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M206.292 267.405C207.179 268.265 208.362 268.641 209.571 268.453C209.84 268.426 209.705 268.023 209.464 268.077C208.389 268.238 207.34 267.889 206.561 267.136C206.373 266.948 206.104 267.217 206.292 267.405Z",
  fill: "white"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M204.868 269.959C204.787 269.959 204.734 269.932 204.653 269.932C204.68 269.905 204.68 269.851 204.707 269.824C204.761 269.878 204.841 269.932 204.895 269.985C204.895 269.932 204.868 269.905 204.868 269.851C204.787 269.609 204.411 269.717 204.492 269.959C204.626 270.55 204.841 271.464 204.116 271.759C203.874 271.867 203.981 272.243 204.223 272.135C205.191 271.732 205.083 270.684 204.895 269.824C204.761 269.851 204.626 269.905 204.519 269.932C204.519 269.985 204.546 270.012 204.546 270.066C204.572 270.147 204.653 270.227 204.734 270.227C205.432 270.174 204.868 269.206 204.546 269.77C204.411 269.959 204.734 270.174 204.868 269.959Z",
  fill: "white"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M204.6 270.146C204.734 270.603 204.761 271.114 205.057 271.517C205.298 271.839 205.675 272.001 206.078 271.92C206.32 271.866 206.212 271.49 205.97 271.544C205.218 271.705 205.11 270.522 204.976 270.039C204.922 269.797 204.546 269.904 204.6 270.146Z",
  fill: "white"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M203.31 270.523C202.53 270.173 201.724 270.012 200.864 270.066C200.595 270.093 200.595 270.496 200.864 270.469C201.643 270.415 202.396 270.55 203.095 270.872C203.336 270.98 203.551 270.63 203.31 270.523Z",
  fill: "white"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M202.611 271.06C201.939 271.114 201.347 271.382 200.891 271.839C200.702 272.027 200.998 272.296 201.186 272.135C201.589 271.759 202.073 271.517 202.637 271.463C202.852 271.436 202.852 271.033 202.611 271.06Z",
  fill: "white"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M206.455 270.335C207.234 270.039 208.013 269.931 208.846 270.012C209.115 270.039 209.115 269.636 208.846 269.609C207.986 269.528 207.153 269.663 206.347 269.958C206.105 270.039 206.186 270.442 206.455 270.335Z",
  fill: "white"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M206.991 271.06C207.582 270.98 208.146 271.033 208.711 271.248C208.953 271.329 209.06 270.953 208.818 270.872C208.227 270.657 207.609 270.603 206.991 270.684C206.722 270.684 206.722 271.114 206.991 271.06Z",
  fill: "white"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M200.649 266.492C201.052 266.25 201.536 266.25 201.939 266.492C202.154 266.626 202.369 266.277 202.154 266.142C201.616 265.847 200.998 265.847 200.461 266.142C200.219 266.277 200.434 266.626 200.649 266.492Z",
  fill: "white"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M206.294 265.954C206.697 265.739 207.154 265.685 207.638 265.739C207.88 265.766 208.014 265.39 207.746 265.363C207.181 265.282 206.617 265.363 206.106 265.632C205.837 265.712 206.052 266.062 206.294 265.954Z",
  fill: "white"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M199.869 257.515C200.703 257.166 201.536 256.816 202.342 256.44C202.181 256.333 202.046 256.225 201.885 256.091C201.563 257.112 201.079 258.026 200.434 258.886C200.273 259.101 200.541 259.423 200.783 259.343C201.697 258.993 202.611 258.671 203.524 258.321C203.874 258.187 203.739 257.596 203.363 257.73C202.449 258.08 201.536 258.402 200.622 258.751C200.729 258.913 200.837 259.047 200.971 259.208C201.67 258.321 202.154 257.354 202.503 256.279C202.584 256.01 202.288 255.849 202.046 255.93C201.213 256.279 200.38 256.628 199.574 257.005C199.198 257.166 199.52 257.676 199.869 257.515Z",
  fill: "#090707"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M201.214 252.625C201.778 252.302 202.343 252.087 202.961 251.953C202.853 251.791 202.746 251.657 202.611 251.496C202.37 252.033 202.074 252.571 201.724 253.055C201.59 253.27 201.778 253.485 201.993 253.511C202.719 253.565 203.391 253.377 203.955 252.947C204.251 252.705 203.955 252.195 203.659 252.436C203.176 252.813 202.638 252.974 202.02 252.92C202.101 253.081 202.181 253.216 202.289 253.377C202.638 252.866 202.934 252.356 203.176 251.818C203.283 251.576 203.095 251.308 202.826 251.361C202.154 251.496 201.509 251.738 200.918 252.087C200.569 252.302 200.864 252.813 201.214 252.625Z",
  fill: "#090707"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M205.647 259.127C204.761 258.241 206.292 257.73 206.454 256.951C206.615 256.037 205.54 255.177 206.749 254.478C207.099 254.29 206.776 253.752 206.454 253.967C206.024 254.209 205.674 254.586 205.567 255.096C205.406 255.956 206.158 256.467 205.513 257.246C205.217 257.622 204.868 257.73 204.761 258.241C204.653 258.751 204.868 259.181 205.217 259.557C205.513 259.826 205.943 259.396 205.647 259.127Z",
  fill: "#090707"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M279.849 182.401C212.474 187.265 145.098 192.103 77.7493 196.967C75.9218 148.108 74.0943 99.2494 72.2937 50.3907C139.965 49.4769 207.636 48.5632 275.307 47.6494C276.812 92.5575 278.317 137.466 279.849 182.401Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.940625,
  strokeMiterlimit: 10
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M129.538 74.1739C142.599 74.1739 155.687 74.1739 168.749 74.1739C169.259 74.1739 169.259 73.3677 168.749 73.3677C155.687 73.3677 142.599 73.3677 129.538 73.3677C129.027 73.3677 129.027 74.1739 129.538 74.1739Z",
  fill: "#090707"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M144.212 77.4801C157.676 77.4801 171.141 77.4801 184.605 77.4801C185.116 77.4801 185.116 76.6738 184.605 76.6738C171.141 76.6738 157.676 76.6738 144.212 76.6738C143.674 76.6738 143.674 77.4801 144.212 77.4801Z",
  fill: "#090707"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M80.4648 156.331C80.9485 167.565 81.4323 178.826 81.916 190.059C81.9429 190.57 82.7491 190.57 82.7223 190.059C82.2385 178.826 81.7548 167.565 81.271 156.331C81.2441 155.821 80.4379 155.821 80.4648 156.331Z",
  fill: "#090707"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M139.67 149.774C140.826 149.774 141.981 149.774 143.164 149.774C143.675 149.774 143.675 148.967 143.164 148.967C142.008 148.967 140.853 148.967 139.67 148.967C139.16 148.967 139.16 149.774 139.67 149.774Z",
  fill: "#090707"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M146.2 149.774C149.184 149.774 152.14 149.774 155.123 149.774C155.634 149.774 155.634 148.967 155.123 148.967C152.14 148.967 149.184 148.967 146.2 148.967C145.69 148.967 145.69 149.774 146.2 149.774Z",
  fill: "#090707"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M161.869 149.344C165.416 149.344 168.964 149.344 172.538 149.344C173.049 149.344 173.049 148.538 172.538 148.538C168.991 148.538 165.443 148.538 161.869 148.538C161.358 148.538 161.358 149.344 161.869 149.344Z",
  fill: "#090707"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M144.481 155.418C148.834 155.418 153.188 155.418 157.542 155.418C158.053 155.418 158.053 154.611 157.542 154.611C153.188 154.611 148.834 154.611 144.481 154.611C143.943 154.611 143.943 155.418 144.481 155.418Z",
  fill: "#090707"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M150.769 152.38C155.849 152.38 160.928 152.38 166.007 152.38C166.518 152.38 166.518 151.574 166.007 151.574C160.928 151.574 155.849 151.574 150.769 151.574C150.259 151.574 150.259 152.38 150.769 152.38Z",
  fill: "#090707"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M177.752 181.11C186.298 181.11 194.871 181.11 203.417 181.11C203.928 181.11 203.928 180.304 203.417 180.304C194.871 180.304 186.298 180.304 177.752 180.304C177.241 180.304 177.241 181.11 177.752 181.11Z",
  fill: "#090707"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M198.849 183.287C203.337 183.287 207.852 183.287 212.34 183.287C212.851 183.287 212.851 182.48 212.34 182.48C207.852 182.48 203.337 182.48 198.849 182.48C198.338 182.48 198.338 183.287 198.849 183.287Z",
  fill: "#090707"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M210.593 180.008C215.028 180.008 219.435 180.008 223.87 180.008C224.38 180.008 224.38 179.202 223.87 179.202C219.435 179.202 215.028 179.202 210.593 179.202C210.083 179.202 210.083 180.008 210.593 180.008Z",
  fill: "#090707"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M233.222 107.15C241.419 107.15 249.616 107.15 257.813 107.15C258.323 107.15 258.323 106.344 257.813 106.344C249.616 106.344 241.419 106.344 233.222 106.344C232.711 106.344 232.711 107.15 233.222 107.15Z",
  fill: "#090707"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M225.616 108.44C228.223 108.44 230.83 108.44 233.437 108.44C233.948 108.44 233.948 107.633 233.437 107.633C230.83 107.633 228.223 107.633 225.616 107.633C225.079 107.633 225.079 108.44 225.616 108.44Z",
  fill: "#090707"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M227.122 110.617C235.883 110.617 244.671 110.617 253.432 110.617C253.943 110.617 253.943 109.811 253.432 109.811C244.671 109.811 235.883 109.811 227.122 109.811C226.611 109.811 226.611 110.617 227.122 110.617Z",
  fill: "#090707"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M259.56 108.655C261.226 108.655 262.892 108.655 264.559 108.655C265.069 108.655 265.069 107.849 264.559 107.849C262.892 107.849 261.226 107.849 259.56 107.849C259.022 107.849 259.022 108.655 259.56 108.655Z",
  fill: "#090707"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M253.029 141.496C255.501 141.496 257.947 141.496 260.419 141.496C260.93 141.496 260.93 140.689 260.419 140.689C257.947 140.689 255.501 140.689 253.029 140.689C252.491 140.689 252.491 141.496 253.029 141.496Z",
  fill: "#090707"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M248.245 143.673C250.932 143.673 253.62 143.673 256.281 143.673C256.791 143.673 256.791 142.867 256.281 142.867C253.593 142.867 250.906 142.867 248.245 142.867C247.707 142.867 247.707 143.673 248.245 143.673Z",
  fill: "#090707"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M252.142 145.85C257.436 145.85 262.731 145.85 268.025 145.85C268.536 145.85 268.536 145.044 268.025 145.044C262.731 145.044 257.436 145.044 252.142 145.044C251.631 145.044 251.631 145.85 252.142 145.85Z",
  fill: "#090707"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M262.166 143.243C263.752 143.243 265.364 143.243 266.95 143.243C267.461 143.243 267.461 142.437 266.95 142.437C265.364 142.437 263.752 142.437 262.166 142.437C261.629 142.437 261.629 143.243 262.166 143.243Z",
  fill: "#090707"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M151.468 109.73C155.231 109.73 158.967 109.73 162.729 109.73C163.24 109.73 163.24 108.924 162.729 108.924C158.967 108.924 155.231 108.924 151.468 108.924C150.958 108.924 150.958 109.73 151.468 109.73Z",
  fill: "#090707"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M159.665 112.041C165.201 112.041 170.764 112.041 176.301 112.041C176.811 112.041 176.811 111.235 176.301 111.235C170.764 111.235 165.201 111.235 159.665 111.235C159.154 111.235 159.127 112.041 159.665 112.041Z",
  fill: "#090707"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M174.258 108.95C177.402 108.95 180.574 108.95 183.718 108.95C184.229 108.95 184.229 108.144 183.718 108.144C180.574 108.144 177.402 108.144 174.258 108.144C173.747 108.144 173.747 108.95 174.258 108.95Z",
  fill: "#090707"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M78.0726 66.0578C78.6639 86.4559 79.2551 106.881 79.8464 127.279C80.0076 133.084 80.1689 138.862 80.357 144.667C80.3839 145.178 81.1901 145.178 81.1633 144.667C80.572 124.269 79.9808 103.844 79.3895 83.4459C79.2283 77.6409 79.067 71.8628 78.8789 66.0578C78.8789 65.5471 78.0726 65.5471 78.0726 66.0578Z",
  fill: "#090707"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M273.427 132.735C273.83 146.226 274.233 159.691 274.636 173.182C274.663 173.693 275.47 173.693 275.443 173.182C275.04 159.691 274.636 146.226 274.233 132.735C274.233 132.224 273.427 132.224 273.427 132.735Z",
  fill: "#090707"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M217.769 126.554C217.93 128.193 218.091 129.86 218.226 131.499C219.785 131.096 221.316 130.666 222.875 130.263C222.66 128.624 222.472 126.957 222.257 125.318C220.752 125.721 219.274 126.151 217.769 126.554Z",
  fill: "#FABB18"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M216.828 139.105C218.441 138.89 220.027 138.702 221.639 138.487C221.854 140.449 222.042 142.411 222.257 144.372C220.806 144.426 219.355 144.48 217.93 144.534C217.554 142.706 217.205 140.906 216.828 139.105Z",
  fill: "#FABB18"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M222.714 151.01C223.225 152.703 223.735 154.423 224.273 156.117C225.724 155.445 227.175 154.773 228.6 154.101C228.143 152.596 227.659 151.118 227.202 149.613C225.724 150.097 224.219 150.553 222.714 151.01Z",
  fill: "#FABB18"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M116.477 167.028C116.826 172.242 117.176 177.455 117.525 182.642C126.663 182.051 135.8 181.487 144.938 180.895C145.099 176.219 145.287 171.516 145.448 166.84C135.8 166.92 126.125 166.974 116.477 167.028Z",
  fill: "#FA6918"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M230.077 60.9525C231.131 60.9525 231.986 60.2426 231.986 59.3669C231.986 58.4912 231.131 57.7812 230.077 57.7812C229.024 57.7812 228.169 58.4912 228.169 59.3669C228.169 60.2426 229.024 60.9525 230.077 60.9525Z",
  fill: "#FA6918"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M100.406 72.8311C101.282 72.8311 101.992 72.3619 101.992 71.783C101.992 71.2041 101.282 70.7349 100.406 70.7349C99.5302 70.7349 98.8203 71.2041 98.8203 71.783C98.8203 72.3619 99.5302 72.8311 100.406 72.8311Z",
  fill: "#FABB18"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M125.641 103.227C126.324 103.227 126.878 102.577 126.878 101.775C126.878 100.974 126.324 100.324 125.641 100.324C124.959 100.324 124.405 100.974 124.405 101.775C124.405 102.577 124.959 103.227 125.641 103.227Z",
  fill: "#FABB18"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.21,
  d: "M114.3 67.026C114.784 66.9453 115.725 71.4335 118.036 79.5766C121.073 90.2997 124.083 98.9535 126.26 104.866C122.954 106.908 115.563 110.805 105.485 110.94C98.3634 111.02 92.7466 109.193 89.4141 107.795C95.9447 108.521 101.212 108.333 104.894 107.983C110.726 107.446 109.705 106.828 114.112 106.613C115.94 106.532 118.332 106.532 120.777 105.054C121.664 104.517 122.309 103.925 122.739 103.495C121.019 99.9478 118.815 94.7341 117.042 88.2035C114.22 77.5878 113.602 67.1603 114.3 67.026Z",
  fill: "#908E8E"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M139.482 96.186C139.912 99.5992 140.692 103.415 141.982 107.5C145.664 119.11 151.872 127.388 156.548 132.494C153.753 134.564 150.286 136.714 146.12 138.514C133.489 143.97 121.691 143.164 115.375 142.196C115.134 140.772 114.892 139.347 114.65 137.923C117.337 138.004 120.186 137.95 123.169 137.789C133.812 137.117 142.949 134.725 150.232 132.064C147.921 128.14 146.255 124.754 145.099 122.201C142.304 116.1 140.235 111.505 139.509 105.297C139.052 101.507 139.24 98.3092 139.482 96.186Z",
  fill: "#908E8E"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.14,
  d: "M224.918 113.977C225.186 120.105 225.831 125.184 226.396 128.839C227.713 137.224 228.68 143.029 232.12 149.56C234.27 153.618 236.689 156.601 238.436 158.536C235.399 161.143 231.314 164.099 226.073 166.464C212.904 172.457 200.542 171.248 194.764 170.28C194.468 168.963 194.173 167.646 193.877 166.303C194.603 166.356 195.731 166.41 197.102 166.437C201.671 166.545 211.184 166.706 222.096 163.051C225.159 162.03 229.459 160.31 234.297 157.461C232.389 154.908 230.508 151.871 228.868 148.35C222.391 134.456 223.681 120.965 224.918 113.977Z",
  fill: "#908E8E"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.18,
  d: "M245.504 53.6963C246.041 56.1957 246.821 60.0119 247.6 64.7688C249.051 73.96 248.944 77.2925 250.637 82.7213C251.524 85.5432 253.109 89.5475 256.093 94.1163C253.593 96.1588 250.476 98.2819 246.633 100.056C234.055 105.888 222.015 104.248 216.479 103.093C216.533 102.018 216.586 100.943 216.64 99.8944C217.339 100.083 218.387 100.324 219.677 100.539C221.37 100.808 227.632 101.722 239.403 98.7657C242.655 97.9594 247.036 96.6694 252.061 94.6C251.094 92.88 249.669 90.1925 248.379 86.7525C244.617 76.7819 244.644 68.1282 244.698 63.6669C244.724 61.2213 244.886 57.8082 245.504 53.6963Z",
  fill: "#908E8E"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M84.8445 65.4933C82.1839 79.5758 84.8714 93.8196 87.5589 107.687C87.6664 108.198 88.4458 107.983 88.3383 107.472C85.6776 93.7658 83.017 79.6565 85.6239 65.7083C85.7045 65.2246 84.9251 64.9827 84.8445 65.4933Z",
  fill: "#090707"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M85.5985 65.3861C89.4416 67.9661 94.091 68.4229 98.6329 68.1004C103.82 67.7242 108.953 66.6223 114.086 65.7623C114.597 65.6817 114.382 64.9023 113.871 64.9829C108.953 65.7892 104.035 66.8373 99.0629 67.2404C94.521 67.6167 89.8716 67.2673 86.0016 64.6604C85.5716 64.3917 85.1685 65.0904 85.5985 65.3861Z",
  fill: "#090707"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M113.548 66.3273C114.3 79.1736 116.235 92.2886 122.739 103.576C123.008 104.033 123.707 103.63 123.438 103.173C117.015 91.9929 115.107 79.0123 114.354 66.3273C114.327 65.8167 113.521 65.8167 113.548 66.3273Z",
  fill: "#090707"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M88.2313 107.902C94.3319 109.676 100.889 108.601 107.098 108.09C112.607 107.634 118.519 107.419 123.249 104.194C123.679 103.898 123.276 103.199 122.846 103.495C118.089 106.747 112.123 106.854 106.587 107.311C100.621 107.795 94.3319 108.789 88.4463 107.096C87.9357 106.989 87.7207 107.768 88.2313 107.902Z",
  fill: "#090707"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M98.5513 71.9439C98.0138 71.702 98.6051 71.1914 98.9276 71.1108C99.3307 71.0033 100.11 70.9495 100.298 71.4064C100.433 71.7558 100.218 72.2127 99.8951 72.347C99.3845 72.5889 98.8201 72.2933 98.4707 71.9439C98.0945 71.5677 97.5301 72.132 97.9063 72.5083C98.5782 73.1801 99.6801 73.5295 100.513 72.9114C101.185 72.4276 101.427 71.3527 100.863 70.7077C100.218 69.982 98.847 70.0627 98.1213 70.6002C97.4763 71.0839 97.342 72.2395 98.1751 72.6158C98.632 72.8577 99.0351 72.1589 98.5513 71.9439Z",
  fill: "#090707"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M109.328 108.01C107.393 117.82 109.463 127.736 111.559 137.358C111.666 137.868 112.446 137.653 112.338 137.143C110.269 127.683 108.226 117.9 110.108 108.225C110.215 107.715 109.436 107.5 109.328 108.01Z",
  fill: "#090707"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M120.428 97.7171C126.636 96.5346 132.925 96.1046 139.213 96.3464C139.079 96.2121 138.945 96.0777 138.81 95.9433C137.547 108.897 143.084 121.233 149.802 131.956C150.071 132.386 150.77 131.983 150.501 131.553C143.863 120.937 138.353 108.763 139.617 95.9433C139.643 95.7283 139.402 95.5402 139.213 95.5402C132.844 95.2983 126.475 95.7552 120.213 96.9377C119.702 97.0452 119.917 97.8246 120.428 97.7171Z",
  fill: "#090707"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M111.989 137.923C125.05 139.455 138.299 137.493 150.393 132.333C150.877 132.118 150.447 131.446 149.99 131.634C138.058 136.74 124.889 138.621 111.989 137.116C111.478 137.063 111.478 137.869 111.989 137.923Z",
  fill: "#090707"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M125.481 101.023C125.481 100.996 125.562 100.861 125.562 100.808C125.589 100.7 125.669 100.593 125.75 100.512C125.911 100.378 126.099 100.27 126.314 100.243C126.718 100.19 127.094 100.405 127.201 100.808C127.282 101.13 127.148 101.56 126.771 101.614C126.422 101.668 126.099 101.426 126.046 101.076C125.965 100.566 125.186 100.781 125.266 101.291C125.401 102.232 126.61 102.689 127.389 102.232C128.249 101.721 128.196 100.405 127.47 99.7864C126.664 99.1145 125.32 99.4639 124.863 100.378C124.648 100.835 124.648 101.453 125.159 101.721C125.562 101.936 126.153 101.748 126.261 101.238C126.341 100.727 125.562 100.512 125.481 101.023Z",
  fill: "#090707"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M87.5058 80.1126C94.6546 81.107 101.75 79.6288 108.603 77.667C109.113 77.5326 108.898 76.7532 108.388 76.8876C101.669 78.7957 94.7083 80.3007 87.7208 79.3332C87.2102 79.2526 86.9952 80.032 87.5058 80.1126Z",
  fill: "#090707"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M88.8494 85.3811C92.5581 85.7842 96.2669 85.408 99.8413 84.2792C100.325 84.118 100.137 83.3386 99.6263 83.4999C96.1325 84.6017 92.5044 84.9511 88.8494 84.5749C88.3388 84.5211 88.3388 85.3274 88.8494 85.3811Z",
  fill: "#090707"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M88.8495 91.8848C95.9445 92.7179 103.093 92.2073 109.973 90.4067C110.484 90.2723 110.269 89.4929 109.758 89.6273C102.932 91.4279 95.8639 91.9117 88.8495 91.0786C88.3389 90.9979 88.3389 91.8042 88.8495 91.8848Z",
  fill: "#090707"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M115.402 133.139C122.524 133.461 129.646 132.601 136.472 130.559C136.956 130.424 136.768 129.645 136.257 129.779C129.484 131.795 122.47 132.655 115.402 132.332C114.864 132.305 114.864 133.112 115.402 133.139Z",
  fill: "#090707"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M116.773 126.985C119.944 126.877 123.115 126.635 126.287 126.286C126.797 126.232 126.797 125.426 126.287 125.48C123.115 125.829 119.971 126.071 116.773 126.178C116.262 126.205 116.262 127.011 116.773 126.985Z",
  fill: "#090707"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M119.353 115.912C121.449 116.181 123.626 115.643 125.695 115.347C127.98 114.998 130.237 114.676 132.521 114.326C133.032 114.246 132.817 113.466 132.306 113.547C130.21 113.869 128.087 114.192 125.991 114.487C123.814 114.81 121.556 115.401 119.353 115.106C118.842 115.025 118.842 115.831 119.353 115.912Z",
  fill: "#090707"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M214.329 55.6572C211.4 70.0353 211.104 84.8166 213.442 99.3022C213.523 99.8128 214.302 99.5978 214.221 99.0872C211.91 84.7628 212.233 70.0891 215.108 55.8722C215.216 55.3616 214.436 55.1466 214.329 55.6572Z",
  fill: "#090707"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M215.243 55.8462C224.998 53.6156 235.076 53.1587 245.02 54.5025C245.531 54.5831 245.746 53.8037 245.235 53.7231C235.157 52.3525 224.945 52.8093 215.028 55.0668C214.544 55.2012 214.759 55.9806 215.243 55.8462Z",
  fill: "#090707"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M244.778 53.776C244.482 67.6167 244.671 82.2367 251.685 94.626C251.954 95.0829 252.626 94.6798 252.384 94.2229C245.45 81.9679 245.289 67.4823 245.584 53.776C245.611 53.2654 244.805 53.2654 244.778 53.776Z",
  fill: "#090707"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M214.06 99.7331C217.07 100.647 220.295 100.701 223.413 100.727C226.772 100.754 230.132 100.539 233.491 100.082C239.914 99.2225 246.176 97.4756 252.169 94.9493C252.653 94.7612 252.223 94.0625 251.766 94.2506C245.773 96.7768 239.457 98.4968 233.007 99.33C229.997 99.7062 226.96 99.9212 223.924 99.8943C220.725 99.8943 217.366 99.8675 214.302 98.9268C213.765 98.8193 213.577 99.5987 214.06 99.7331Z",
  fill: "#090707"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M230.508 56.706C229.594 57.0285 229.191 58.0766 229.513 58.9635C229.89 59.9579 231.045 60.1998 231.905 59.6085C232.738 59.0173 233.007 57.8348 232.201 57.0823C231.502 56.4373 230.293 56.4104 229.648 57.1091C229.298 57.4854 229.863 58.0498 230.212 57.6735C231.018 56.8135 232.604 58.0229 231.502 58.8829C231.072 59.2054 230.454 59.2054 230.266 58.641C230.132 58.211 230.266 57.6198 230.723 57.4585C231.207 57.2973 230.992 56.5179 230.508 56.706Z",
  fill: "#090707"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M214.732 68.1549C222.069 68.343 229.379 68.2086 236.689 67.7249C237.199 67.698 237.199 66.8918 236.689 66.9186C229.379 67.4024 222.042 67.5636 214.732 67.3486C214.194 67.3486 214.194 68.1549 214.732 68.1549Z",
  fill: "#090707"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M215.458 72.24C218.199 72.3475 220.94 72.455 223.655 72.5625C224.165 72.5894 224.165 71.7831 223.655 71.7563C220.913 71.6488 218.172 71.5413 215.458 71.4338C214.92 71.4069 214.92 72.2131 215.458 72.24Z",
  fill: "#090707"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M214.705 77.9371C221.612 78.3133 228.6 78.6358 235.399 77.1308C235.91 77.0233 235.695 76.244 235.184 76.3515C228.438 77.8296 221.532 77.5071 214.705 77.1308C214.195 77.104 214.195 77.9102 214.705 77.9371Z",
  fill: "#090707"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M114.515 165.308C113.897 170.683 113.682 176.085 113.87 181.487C113.897 181.997 114.703 181.997 114.676 181.487C114.488 176.085 114.703 170.683 115.321 165.308C115.375 164.797 114.569 164.797 114.515 165.308Z",
  fill: "#090707"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M114.784 165.63C124.351 165.63 133.946 165.496 143.513 165.2C144.024 165.174 144.024 164.367 143.513 164.394C133.946 164.69 124.351 164.824 114.784 164.824C114.273 164.824 114.273 165.63 114.784 165.63Z",
  fill: "#090707"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M143.433 164.824C143.514 169.501 143.594 174.15 143.675 178.826C143.675 179.337 144.481 179.337 144.481 178.826C144.4 174.15 144.32 169.501 144.239 164.824C144.239 164.314 143.406 164.314 143.433 164.824Z",
  fill: "#090707"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M113.789 180.895C113.843 182.642 116.88 181.863 117.874 181.809C120.723 181.621 123.572 181.433 126.394 181.218C132.172 180.815 137.95 180.439 143.728 180.035C144.239 180.009 144.239 179.202 143.728 179.229C138.81 179.552 133.919 179.901 129.001 180.224C126.663 180.385 124.324 180.546 121.986 180.707C121.288 180.761 114.596 181.406 114.569 180.895C114.596 180.385 113.789 180.385 113.789 180.895Z",
  fill: "#090707"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M116.96 169.258C123.41 168.963 129.86 169.204 136.256 170.011C136.767 170.064 136.767 169.258 136.256 169.204C129.86 168.398 123.41 168.156 116.96 168.452C116.423 168.479 116.423 169.285 116.96 169.258Z",
  fill: "#090707"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M117.203 173.344C120.804 173.075 124.432 172.779 128.033 172.511C128.544 172.484 128.544 171.677 128.033 171.704C124.432 171.973 120.804 172.269 117.203 172.537C116.692 172.564 116.692 173.371 117.203 173.344Z",
  fill: "#090707"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M118.412 177.455C123.599 176.783 129.243 175.412 134.456 176.353C134.967 176.433 135.182 175.681 134.671 175.573C129.35 174.606 123.706 175.95 118.412 176.648C117.928 176.729 117.901 177.535 118.412 177.455Z",
  fill: "#090707"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M188.314 119.567C184.041 134.778 184.578 151.064 189.819 165.98C189.98 166.464 190.759 166.249 190.598 165.765C185.411 150.984 184.874 134.859 189.093 119.782C189.228 119.271 188.448 119.056 188.314 119.567Z",
  fill: "#090707"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M188.851 119.835C200.81 119.782 212.716 118.223 224.299 115.186C224.809 115.052 224.594 114.272 224.084 114.407C212.581 117.417 200.756 118.975 188.851 119.029C188.313 119.029 188.313 119.835 188.851 119.835Z",
  fill: "#090707"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M224.085 114.703C223.601 122.174 223.924 129.699 225.267 137.09C225.939 140.825 226.745 144.561 228.224 148.055C229.702 151.522 231.744 154.666 234.136 157.542C234.459 157.945 235.05 157.38 234.7 156.977C232.255 154.048 230.185 150.796 228.734 147.248C227.364 143.862 226.611 140.234 225.993 136.66C224.703 129.43 224.407 122.04 224.864 114.703C224.918 114.192 224.112 114.192 224.085 114.703Z",
  fill: "#090707"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M189.926 166.41C205.138 167.485 221.021 165.765 234.351 157.918C234.808 157.649 234.404 156.95 233.948 157.219C220.698 165.013 204.976 166.652 189.926 165.604C189.416 165.55 189.416 166.357 189.926 166.41Z",
  fill: "#090707"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M206.105 122.255C205.648 121.476 206.562 120.508 207.341 121.126C208.175 121.798 207.288 122.873 206.401 122.524C205.917 122.336 205.702 123.115 206.186 123.303C206.911 123.599 207.798 123.276 208.228 122.631C208.712 121.906 208.497 120.992 207.825 120.481C206.374 119.326 204.546 121.126 205.406 122.658C205.675 123.115 206.374 122.712 206.105 122.255Z",
  fill: "#090707"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M189.12 131.526C197.156 131.391 205.191 130.827 213.2 129.86C213.711 129.806 213.711 129 213.2 129.053C205.218 130.048 197.183 130.585 189.12 130.72C188.609 130.746 188.609 131.553 189.12 131.526Z",
  fill: "#090707"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M216.076 126.124C216.318 127.36 216.559 128.624 216.801 129.86C216.909 130.37 217.688 130.155 217.581 129.645C217.339 128.409 217.097 127.145 216.855 125.909C216.774 125.399 215.995 125.614 216.076 126.124Z",
  fill: "#090707"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M216.613 126.017C218.091 125.802 219.569 125.587 221.074 125.345C221.585 125.265 221.37 124.485 220.859 124.566C219.381 124.781 217.903 124.996 216.398 125.238C215.887 125.318 216.102 126.098 216.613 126.017Z",
  fill: "#090707"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M220.833 125.103C221.048 126.259 221.236 127.415 221.451 128.543C221.532 129.054 222.311 128.839 222.23 128.328C222.015 127.173 221.827 126.017 221.612 124.888C221.532 124.405 220.752 124.62 220.833 125.103Z",
  fill: "#090707"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M217.473 130.478C219.059 130.156 220.564 129.726 222.069 129.135C222.553 128.946 222.338 128.167 221.854 128.355C220.349 128.92 218.817 129.376 217.258 129.699C216.748 129.806 216.963 130.586 217.473 130.478Z",
  fill: "#090707"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M217.607 126.931C217.903 127.602 218.306 128.14 218.897 128.597C219.112 128.758 219.516 128.758 219.569 128.409C219.784 126.957 220.295 125.667 221.155 124.458C221.451 124.028 220.752 123.625 220.456 124.055C219.569 125.291 219.005 126.689 218.79 128.194C219.005 128.14 219.247 128.086 219.462 128.006C218.951 127.602 218.575 127.119 218.306 126.501C218.091 126.044 217.392 126.447 217.607 126.931Z",
  fill: "#090707"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M217.903 138.459C217.473 140.394 217.661 142.276 218.441 144.076C218.656 144.56 219.327 144.13 219.139 143.673C218.441 142.088 218.306 140.368 218.682 138.674C218.79 138.164 218.011 137.949 217.903 138.459Z",
  fill: "#090707"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M218.441 138.728C220.053 138.459 221.666 138.217 223.278 137.949C223.117 137.787 222.956 137.626 222.795 137.465C222.526 139.185 222.714 140.824 223.386 142.437C223.574 142.921 224.353 142.706 224.165 142.222C223.547 140.771 223.332 139.239 223.574 137.68C223.628 137.357 223.413 137.142 223.09 137.196C221.478 137.438 219.865 137.707 218.253 137.976C217.715 138.029 217.93 138.809 218.441 138.728Z",
  fill: "#090707"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M218.79 144.104C220.564 144.05 222.257 143.701 223.923 143.11C224.407 142.922 224.192 142.142 223.708 142.33C222.123 142.922 220.483 143.244 218.79 143.298C218.28 143.298 218.28 144.104 218.79 144.104Z",
  fill: "#090707"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M219.032 140.368C219.274 141.067 219.677 141.551 220.322 141.927C220.618 142.088 220.887 141.873 220.94 141.577C221.102 140.153 221.478 138.782 222.069 137.466C222.284 137.009 221.585 136.579 221.37 137.062C220.725 138.514 220.322 140.019 220.134 141.577C220.349 141.47 220.537 141.336 220.752 141.228C220.295 140.959 220.027 140.637 219.838 140.126C219.65 139.669 218.871 139.884 219.032 140.368Z",
  fill: "#090707"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M219.569 150.93C219.757 152.73 220.241 154.424 221.047 156.036C221.262 156.493 221.961 156.09 221.746 155.633C221.021 154.155 220.564 152.569 220.402 150.93C220.322 150.419 219.516 150.419 219.569 150.93Z",
  fill: "#090707"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M219.946 150.849C222.015 151.037 223.95 150.661 225.805 149.747C225.617 149.667 225.402 149.586 225.214 149.505C225.563 151.145 226.289 152.569 227.417 153.832C227.767 154.208 228.331 153.644 227.982 153.268C226.96 152.112 226.315 150.822 225.993 149.317C225.939 149.048 225.617 148.968 225.402 149.075C223.682 149.908 221.854 150.231 219.946 150.07C219.435 150.016 219.435 150.822 219.946 150.849Z",
  fill: "#090707"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M221.773 156.332C223.87 155.553 225.939 154.719 227.955 153.806C228.438 153.591 228.008 152.892 227.552 153.107C225.59 153.994 223.574 154.8 221.558 155.553C221.075 155.741 221.29 156.52 221.773 156.332Z",
  fill: "#090707"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M221.343 152.272C221.988 152.837 223.466 154.772 224.219 153.347C224.568 152.702 224.487 151.815 224.702 151.09C225.025 150.069 225.562 149.128 226.261 148.322C226.584 147.919 226.019 147.354 225.697 147.757C224.944 148.644 224.353 149.612 224.004 150.74C223.842 151.251 223.708 151.789 223.627 152.326C223.52 152.998 223.332 152.837 222.821 152.514C222.499 152.299 222.203 151.977 221.907 151.708C221.531 151.359 220.967 151.923 221.343 152.272Z",
  fill: "#090707"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M189.846 144.668C197.371 144.587 204.869 143.969 212.287 142.787C212.797 142.706 212.582 141.927 212.072 142.007C204.708 143.163 197.291 143.781 189.846 143.835C189.336 143.862 189.336 144.668 189.846 144.668Z",
  fill: "#090707"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M188.986 133.757C193.85 133.891 198.688 133.73 203.525 133.327C204.036 133.273 204.036 132.467 203.525 132.521C198.688 132.924 193.823 133.058 188.986 132.951C188.475 132.924 188.475 133.73 188.986 133.757Z",
  fill: "#090707"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M190.142 146.254C195.248 146.495 200.354 146.307 205.407 145.662C205.917 145.609 205.917 144.802 205.407 144.856C200.327 145.474 195.221 145.689 190.142 145.447C189.631 145.42 189.631 146.227 190.142 146.254Z",
  fill: "#090707"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M207.126 145.286C208.578 145.313 210.002 145.125 211.399 144.668C211.883 144.507 211.668 143.727 211.184 143.889C209.868 144.319 208.524 144.507 207.126 144.48C206.616 144.48 206.616 145.286 207.126 145.286Z",
  fill: "#090707"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M192.883 156.359C199.01 155.982 205.111 155.418 211.185 154.585C211.695 154.504 211.695 153.698 211.185 153.779C205.111 154.585 199.01 155.176 192.883 155.552C192.345 155.579 192.345 156.385 192.883 156.359Z",
  fill: "#090707"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M193.581 158.24C195.597 158.24 197.612 158.24 199.628 158.24C200.139 158.24 200.139 157.434 199.628 157.434C197.612 157.434 195.597 157.434 193.581 157.434C193.071 157.434 193.071 158.24 193.581 158.24Z",
  fill: "#090707"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M195.328 160.04C198.473 159.852 201.617 159.556 204.762 159.18C207.288 158.857 210.002 158.723 212.179 157.245C212.609 156.949 212.206 156.25 211.776 156.546C209.492 158.105 206.428 158.185 203.767 158.481C200.972 158.804 198.15 159.045 195.355 159.234C194.818 159.26 194.791 160.067 195.328 160.04Z",
  fill: "#090707"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M226.02 138.325C230.911 138.083 235.775 137.438 240.586 136.417C240.425 136.336 240.263 136.229 240.102 136.148C242.36 142.867 245.692 149.129 249.965 154.8C250.261 155.203 250.987 154.8 250.664 154.396C246.445 148.806 243.139 142.598 240.882 135.96C240.801 135.745 240.613 135.638 240.398 135.691C235.668 136.713 230.884 137.331 226.047 137.573C225.482 137.546 225.482 138.352 226.02 138.325Z",
  fill: "#090707"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M226.852 161.007C227.578 162.029 228.169 163.104 228.68 164.259C228.734 164.42 228.976 164.501 229.137 164.447C233.087 163.13 236.984 161.679 240.801 160.04C242.736 159.207 244.644 158.347 246.552 157.433C247.466 157.003 248.379 156.546 249.266 156.089C249.804 155.82 250.422 155.659 250.61 155.068C250.664 154.907 250.583 154.692 250.422 154.611C250.18 154.477 250.046 154.477 249.804 154.611C249.642 154.692 249.562 154.907 249.616 155.068C249.616 155.095 249.642 155.122 249.642 155.149C249.777 155.659 250.556 155.444 250.422 154.934C250.422 154.907 250.395 154.88 250.395 154.853C250.341 155.014 250.261 155.149 250.207 155.31C250.153 155.31 250.072 155.31 250.019 155.31C249.965 155.149 249.884 155.014 249.831 154.853C249.669 155.337 247.976 155.847 247.519 156.089C246.767 156.465 246.014 156.815 245.235 157.191C243.434 158.051 241.607 158.857 239.752 159.637C236.205 161.142 232.577 162.485 228.922 163.695C229.083 163.749 229.217 163.829 229.379 163.883C228.895 162.727 228.277 161.652 227.551 160.631C227.256 160.174 226.557 160.577 226.852 161.007Z",
  fill: "#090707"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M231.529 140.422C231.475 140.072 232.12 139.75 232.362 139.992C232.684 140.314 232.147 140.906 231.771 140.771C231.287 140.583 231.072 141.362 231.556 141.551C232.711 141.981 233.84 140.314 232.953 139.427C232.55 139.024 231.932 139.051 231.448 139.293C230.938 139.562 230.669 140.072 230.776 140.637C230.83 141.147 231.609 140.906 231.529 140.422Z",
  fill: "#090707"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M112.446 118.922C115.429 118.975 118.439 118.841 121.395 118.438C124.486 118.008 127.549 117.121 130.694 117.255C131.204 117.282 131.204 116.476 130.694 116.449C127.818 116.342 125.023 117.067 122.201 117.497C118.976 118.008 115.698 118.196 112.419 118.115C111.935 118.115 111.935 118.922 112.446 118.922Z",
  fill: "#090707"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M112.876 110.026C117.445 110.376 122.013 109.972 126.448 108.817C126.958 108.682 126.743 107.903 126.233 108.037C121.852 109.166 117.391 109.569 112.876 109.22C112.365 109.193 112.365 109.999 112.876 110.026Z",
  fill: "#090707"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M216.291 87.3974C215.834 90.3537 215.458 93.5518 217.312 96.1318C217.608 96.5618 218.307 96.1587 218.011 95.7287C216.291 93.3368 216.667 90.3537 217.07 87.6124C217.151 87.1018 216.372 86.8868 216.291 87.3974Z",
  fill: "#090707"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M216.533 87.3706C222.929 87.6125 229.325 86.9943 235.56 85.5162C235.399 85.4356 235.238 85.3281 235.076 85.2475C235.641 88.0156 236.716 90.5956 238.221 92.9606C238.489 93.3906 239.188 92.9874 238.919 92.5574C237.441 90.2462 236.42 87.7199 235.856 85.0324C235.802 84.8174 235.56 84.7099 235.372 84.7637C229.218 86.2149 222.902 86.8331 216.559 86.5912C216.022 86.5375 216.022 87.3437 216.533 87.3706Z",
  fill: "#090707"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M217.984 96.1052C224.918 95.8902 231.771 94.869 238.436 93.0415C238.947 92.9071 238.732 92.1277 238.221 92.2621C231.61 94.0896 224.837 95.1108 217.984 95.299C217.447 95.3258 217.447 96.1321 217.984 96.1052Z",
  fill: "#090707"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M312.744 283.828C312.744 286.864 312.744 289.874 312.744 292.911C291.244 301.431 286.863 304.468 287.186 305.569C287.267 305.838 287.831 306.644 299.118 305.328C310.298 304.011 319.355 302.103 325.644 300.544C324.542 294.336 323.413 288.128 322.312 281.919C319.113 282.564 315.915 283.209 312.744 283.828Z",
  fill: "#090707"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M322.392 155.284C321.774 156.44 321.559 157.381 321.505 157.596C317.662 173.936 312.637 183.584 309.358 202.531C303.096 239.027 308.498 280.495 309.009 284.392C310.729 285.144 314.034 286.273 318.254 286.112C321.962 285.951 324.838 284.849 326.477 284.069C325.859 272.164 326.477 257.463 330.589 241.258C335.615 221.397 341.984 214.813 347.709 191.593C351.955 174.393 356.873 154.371 348.38 148.431C341.877 143.809 326.639 147.195 322.392 155.284Z",
  fill: "#FABB18"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M337.254 163.858C332.954 183.477 328.95 204.385 325.564 226.504C322.366 247.305 319.974 267.219 318.2 286.139C320.914 285.575 323.602 285.01 326.316 284.446C325.967 276.088 326.343 268.966 326.881 263.51C327.526 256.738 329.165 240.962 335.749 225.214C336.609 223.198 337.711 220.752 339.512 216.157C342.549 208.551 344.752 202.047 345.747 198.984C350.423 184.364 352.761 167.405 353.487 161.815C348.058 162.46 342.656 163.159 337.254 163.858Z",
  fill: "#908E8E"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.19,
  d: "M346.123 198.016C335.588 211.749 330.67 224.192 328.197 232.55C325.94 240.156 324.945 246.874 323.655 255.582C321.828 267.944 321.129 278.372 320.833 285.789C322.607 285.359 324.354 284.902 326.128 284.472C325.832 274.072 326.558 265.176 327.445 258.243C328.52 250.019 329.756 240.478 334.056 229.002C335.615 224.837 336.367 223.654 339.915 214.651C342.656 207.61 344.752 201.832 346.123 198.016Z",
  fill: "#908E8E"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M370.795 280.736C372.3 284.471 373.832 288.207 375.337 291.969C362.706 300.005 356.74 304.681 357.412 306.052C358.245 307.745 369.156 304.386 390.145 296.028C387.915 288.771 385.684 281.542 383.453 274.286C379.234 276.436 375.015 278.586 370.795 280.736Z",
  fill: "#090707"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M360.421 155.606C367.005 161.626 366.79 170.065 367.623 184.04C367.623 184.04 369.666 218.413 376.519 246.041C378.239 252.948 381.356 263.671 387.135 276.517C386.167 277.753 383.533 280.763 378.911 282.349C374.181 283.961 370.15 283.101 368.645 282.698C360.421 268.669 354.589 256.71 350.826 248.433C333.385 210.216 331.987 190.087 331.987 179.579C331.987 168.775 332.175 155.821 340.211 151.494C346.258 148.243 355.126 150.769 360.421 155.606Z",
  fill: "#FABB18"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M341.77 159.718C344.754 171.193 347.979 182.857 351.419 194.682C360.395 225.373 370.15 254.371 380.39 281.569C381.384 281.058 382.594 280.36 383.83 279.419C385.093 278.451 386.087 277.484 386.84 276.624C385.442 273.372 383.507 268.669 381.465 262.891C378.374 254.049 373.349 237.79 370.742 216.128C368.242 195.327 366.979 184.927 367.087 178.369C367.167 172.967 367.651 161.975 360.664 156.063C359.212 154.853 357.788 154.128 356.794 153.698C351.768 155.713 346.769 157.729 341.77 159.718Z",
  fill: "#908E8E"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.22,
  d: "M367.409 185.357C366.173 197.854 365.77 214.597 368.78 233.947C371.816 253.404 377.326 269.288 382.298 280.844C383.83 279.581 385.361 278.318 386.893 277.028C385.066 272.701 382.674 266.681 380.282 259.317C375.686 245.154 373.698 234.108 371.978 224.191C370.231 214.033 368.403 200.891 367.409 185.357Z",
  fill: "#908E8E"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M241.58 57.4326C240.505 57.9701 239.027 58.9107 237.871 60.5232C237.253 61.3564 236.501 62.4582 236.393 64.017C236.366 64.6351 236.286 65.9789 237.146 66.8657C237.388 67.1345 238.033 67.6451 241.204 67.5376C244.026 67.4301 245.45 67.3764 246.176 66.6239C247.573 65.1726 247.063 62.4314 246.176 60.792C244.778 58.1851 242.037 57.5401 241.58 57.4326Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M257.812 64.1774C261.601 68.5042 267.675 71.0842 278.828 75.6799C292.884 81.4849 299.925 84.3874 308.256 85.4086C317.259 86.5105 322.07 85.3549 323.736 88.2842C325.913 92.0736 320.807 99.1686 315.539 105.108C311.616 104.248 307.558 103.173 303.365 101.775C280.387 94.1699 263.778 80.7861 252.867 69.6599C251.496 69.9555 249.158 70.2511 246.498 69.4449C244.213 68.773 240.988 67.053 241.176 65.6824C241.418 64.0161 247.25 63.7205 247.599 63.6936C245.826 62.968 243.273 61.7317 240.504 59.7161C239.698 59.1249 235.076 55.7117 235.64 54.6367C236.124 53.6961 240.316 54.9861 244.267 56.1955C247.868 57.2974 250.368 58.0767 253.109 59.958C255.743 61.7317 257.274 63.5592 257.812 64.1774Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M239.215 57.7281C239.86 58.4537 239.995 59.4212 240.559 60.1737C241.043 60.8456 241.741 61.3293 242.467 61.7325C244.644 62.9418 246.955 63.9362 249.186 65.0381C249.562 65.2262 250.046 64.7156 249.67 64.3931C248.514 63.3987 247.278 62.5118 245.988 61.7056C245.558 61.4368 245.128 62.1356 245.585 62.4043C246.821 63.1837 248.003 64.0168 249.105 64.9575C249.266 64.7425 249.428 64.5275 249.589 64.3125C247.466 63.2912 245.343 62.2968 243.246 61.195C242.252 60.6843 241.365 60.0931 240.855 59.0718C240.505 58.3731 240.317 57.7012 239.78 57.11C239.43 56.7875 238.866 57.3518 239.215 57.7281Z",
  fill: "white"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M241.311 60.5499C242.548 61.0874 243.73 61.7861 244.805 62.6193C245.208 62.9418 245.773 62.3774 245.37 62.0549C244.241 61.168 243.031 60.4424 241.715 59.8511C241.231 59.6361 240.828 60.3349 241.311 60.5499Z",
  fill: "white"
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M238.14 57.2443C239.161 58.8836 240.505 60.2274 242.091 61.3024C242.521 61.598 242.924 60.8993 242.494 60.6036C241.016 59.6093 239.779 58.3461 238.839 56.8143C238.57 56.4111 237.871 56.8143 238.14 57.2443Z",
  fill: "white"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M239.349 59.4483C239.887 60.1739 240.478 60.8458 241.15 61.437C241.634 61.867 243.757 63.3989 242.655 64.1783C242.44 64.3127 242.655 64.6621 242.87 64.5277C243.622 64.0171 243.327 63.1033 242.87 62.4852C242.521 62.0283 242.037 61.6789 241.58 61.2758C240.881 60.6577 240.263 59.9858 239.699 59.2602C239.537 59.0183 239.188 59.2333 239.349 59.4483Z",
  fill: "#090707"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M238.785 62.243C239.591 63.3449 241.123 64.9037 242.628 64.4468C242.87 64.3662 242.763 63.9899 242.521 64.0705C241.231 64.4737 239.806 62.9955 239.134 62.0549C238.973 61.8399 238.624 62.028 238.785 62.243Z",
  fill: "#090707"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M237.602 64.1244C238.489 65.3337 239.779 66.0325 241.284 66.1131C241.553 66.14 241.553 65.7369 241.284 65.71C239.941 65.6294 238.758 64.9844 237.952 63.9094C237.791 63.6944 237.441 63.9094 237.602 64.1244Z",
  fill: "#090707"
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M236.743 66.5429C238.006 67.8598 240.102 67.8866 241.365 66.5429C241.553 66.3548 241.257 66.0591 241.069 66.2473C239.967 67.4298 238.14 67.4029 237.038 66.2473C236.85 66.0591 236.554 66.3548 236.743 66.5429Z",
  fill: "#090707"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M237.012 57.1907C239.995 59.1525 242.145 62.4582 245.88 63.1032C246.122 63.1569 246.256 62.7538 245.988 62.7269C242.306 62.1088 240.156 58.8032 237.226 56.8682C236.985 56.68 236.797 57.0294 237.012 57.1907Z",
  fill: "#090707"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M236.689 65.9791C235.721 64.6622 236.528 61.8403 238.866 59.1797C241.5 60.7116 244.106 62.2703 246.74 63.8022C246.256 63.8022 242.01 63.8559 241.715 65.1728C241.661 65.3878 241.715 65.7103 242.118 66.1672C243.461 66.8122 245.719 67.6722 248.621 67.7528C250.126 67.7797 251.443 67.5916 252.465 67.3497C257.947 72.8859 267.595 81.2441 281.785 87.3178C294.255 92.6391 305.435 94.1709 312.826 94.6009C312.584 97.7722 312.342 100.917 312.1 104.088C299.926 100.863 283.425 94.7353 267.031 82.4266C261.441 78.2341 256.657 73.9072 252.572 69.7416C248.81 70.3597 246.471 69.7147 244.993 68.9622C243.73 68.3172 242.924 67.5109 241.258 67.3766C240.156 67.2959 239.215 67.5647 238.006 66.9734C237.871 66.9197 237.092 66.5166 236.689 65.9791Z",
  fill: "#908E8E"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.14,
  d: "M271.304 84.9521C275.066 86.9678 279.42 89.0103 284.392 90.7572C295.222 94.6003 305.032 95.8096 312.53 96.0784C312.422 98.8196 312.342 101.588 312.234 104.329C304.441 102.502 294.658 99.3034 284.284 93.4984C279.312 90.7303 275.012 87.8009 271.304 84.9521Z",
  fill: "#908E8E"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M313.792 92.6114C312.261 96.0783 312.18 98.9539 312.046 104.114C311.938 108.011 312.207 112.203 314.303 123.222C316.856 136.552 318.066 138.702 318.469 145.77C318.791 151.306 318.361 155.848 317.958 158.858C321.344 160.713 327.015 163.239 334.432 163.803C347.547 164.798 357.249 159.02 360.582 156.816C360.985 148.377 361.388 139.911 361.818 131.473C360.34 124.27 358.593 118.626 357.33 114.918C353.352 103.227 349.644 97.6908 352.009 91.832C353.326 88.5802 355.932 86.5914 357.733 85.4895C356.47 84.522 343.221 74.7127 328.762 79.792C327.257 80.3027 317.743 83.662 313.792 92.6114Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.19,
  d: "M328.708 79.7661C332.739 86.2161 334.997 91.9136 336.287 95.8911C336.287 95.8911 342.603 115.08 337.98 140.826C336.986 146.309 335.212 154.102 331.718 163.025C333.062 163.32 334.674 163.562 336.502 163.643C336.502 163.643 339.324 163.777 342.495 163.374C346.365 162.864 353.003 160.794 360.824 156.817C360.958 147.814 361.093 138.837 361.227 129.834C359.238 122.229 357.223 116.128 355.718 111.855C352.089 101.669 349.536 96.8855 351.633 91.833C353.003 88.5274 355.798 86.4849 357.975 85.3024C355.126 83.4211 349.859 80.4917 342.656 79.363C336.717 78.4492 331.826 79.0942 328.708 79.7661Z",
  fill: "#908E8E"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.11,
  d: "M332.39 79.1479C336.717 84.4692 341.769 92.2361 344.887 102.475C353.729 131.715 339.189 157.354 335.83 162.971C338.652 162.944 341.957 162.702 345.559 162.004C351.982 160.767 357.115 158.564 360.797 156.602C360.931 148.217 361.066 139.832 361.2 131.474C358.916 123.707 356.765 116.343 353.836 106.345C351.847 99.4923 350.289 93.8755 353.218 89.3873C354.642 87.2105 356.631 86.0011 358.136 85.3023C349.563 83.2329 340.963 81.1904 332.39 79.1479Z",
  fill: "#908E8E"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M330.4 134.054C330.32 128.302 330.266 122.578 330.185 116.827C343.972 116.128 357.759 115.429 371.573 114.73C372.056 120.052 372.54 125.373 373.051 130.694C358.834 131.823 344.617 132.925 330.4 134.054Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M326.208 132.172C326.208 130.076 326.208 127.98 326.208 125.883C343.919 124.566 361.629 123.223 379.34 121.906C379.474 124.486 379.609 127.093 379.77 129.673C361.925 130.479 344.053 131.339 326.208 132.172Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M327.686 122.712C327.901 125.803 328.116 128.867 328.304 131.957C344.698 130.64 361.065 129.297 377.459 127.98C377.593 125.185 377.727 122.39 377.889 119.568C361.146 120.616 344.402 121.664 327.686 122.712Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "M323.682 129.646C324.165 141.901 324.649 154.156 325.16 166.411C343.435 164.369 361.71 162.353 379.985 160.31C380.549 148.27 381.113 136.23 381.678 124.19C362.328 126.018 343.005 127.819 323.682 129.646Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M326.8 134.428C335.104 133.326 343.409 132.547 351.767 132.063C352.143 132.036 352.143 131.445 351.767 131.445C343.409 131.929 335.077 132.708 326.8 133.81C326.424 133.864 326.424 134.482 326.8 134.428Z",
  fill: "#090707"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M336.071 136.069C342.441 135.263 348.81 134.43 355.206 133.623C355.582 133.57 355.582 132.978 355.206 133.005C348.837 133.812 342.468 134.645 336.071 135.451C335.695 135.532 335.695 136.123 336.071 136.069Z",
  fill: "#090707"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M366.681 153.269C366.574 154.962 366.574 156.682 366.735 158.375C366.762 158.752 367.38 158.752 367.353 158.375C367.192 156.682 367.165 154.962 367.3 153.269C367.326 152.893 366.708 152.893 366.681 153.269Z",
  fill: "#090707"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M366.952 153.322C370.285 153.402 373.59 153.214 376.896 152.784C376.788 152.677 376.681 152.569 376.6 152.489C376.546 154.047 376.6 155.579 376.708 157.111C376.735 157.487 377.353 157.487 377.326 157.111C377.191 155.579 377.165 154.02 377.218 152.489C377.218 152.327 377.084 152.166 376.923 152.193C373.617 152.623 370.311 152.784 366.979 152.73C366.549 152.704 366.549 153.295 366.952 153.322Z",
  fill: "#090707"
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M367.192 158.859C370.498 158.913 373.75 158.564 376.975 157.838C377.351 157.757 377.19 157.166 376.813 157.247C373.642 157.946 370.444 158.295 367.192 158.241C366.816 158.241 366.816 158.832 367.192 158.859Z",
  fill: "#090707"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M368.456 155.203C370.499 155.337 372.514 155.23 374.557 154.907C374.933 154.853 374.772 154.262 374.396 154.316C372.434 154.638 370.445 154.719 368.456 154.585C368.08 154.558 368.08 155.176 368.456 155.203Z",
  fill: "#090707"
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M369.745 156.897C371.869 156.844 373.911 156.441 375.927 155.715C376.276 155.581 376.142 154.989 375.765 155.124C373.83 155.849 371.815 156.226 369.745 156.306C369.369 156.279 369.342 156.897 369.745 156.897Z",
  fill: "#090707"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M332.362 165.014C332.846 153.673 333.33 142.331 333.787 130.963C349.482 129.7 365.204 128.464 380.899 127.201C380.549 137.951 380.173 148.701 379.824 159.451C363.994 161.305 348.192 163.159 332.362 165.014Z",
  fill: "#908E8E"
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M374.986 119.863C375.066 122.981 374.905 126.69 374.099 130.801C372.11 140.906 367.326 148.19 364.075 152.301C366.278 155.231 368.482 158.16 370.713 161.09C363.967 161.869 357.221 162.648 350.476 163.428C351.551 151.119 352.626 138.81 353.701 126.528C353.351 124.916 352.975 123.303 352.626 121.691C360.07 121.046 367.541 120.455 374.986 119.863Z",
  fill: "#908E8E"
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  d: "M356.282 84.7639C361.899 84.0114 368.591 96.9114 371.251 106.183C374.315 116.853 372.971 126.071 371.87 130.935C369.72 140.476 365.258 147.195 362.463 150.823C362.893 152.247 363.888 156.117 362.248 160.363C359.83 166.571 353.272 169.555 352.761 168.99C352.6 168.802 352.923 168.023 355.476 165.093C354.938 165.658 351.068 169.501 346.715 168.587C345.962 168.426 345.021 168.238 344.484 167.485C343.221 165.658 345.317 161.519 349.778 156.923C344.914 158.133 343.624 157.81 343.382 157.273C342.764 155.983 347.736 152.328 349.536 150.984C352.197 149.022 354.589 147.678 356.228 146.845C360.824 137.305 360.582 129.86 360.179 126.366C359.588 121.206 357.653 115.59 357.276 114.515C356.201 111.424 355.691 110.725 353.541 105.162C350.074 96.2395 350.074 94.7077 350.208 93.5252C350.692 89.9777 353.084 85.1939 356.282 84.7639Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M344.591 166.733C347.574 165.04 350.181 162.863 352.357 160.229C352.68 159.826 352.116 159.261 351.793 159.665C349.67 162.245 347.117 164.395 344.187 166.061C343.731 166.276 344.134 166.975 344.591 166.733Z",
  fill: "#090707"
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  d: "M347.224 168.533C350.18 167.001 352.707 164.878 354.749 162.244C355.072 161.841 354.373 161.438 354.05 161.841C352.115 164.368 349.643 166.383 346.821 167.834C346.364 168.076 346.767 168.775 347.224 168.533Z",
  fill: "#090707"
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.17,
  d: "M354.024 86.0543C348.675 90.7037 370.498 111.102 366.762 134.268C364.209 150.151 353.62 160.525 353.62 160.525C350.664 163.481 345.101 167.109 345.773 168.372C346.257 169.286 349.616 168.453 350.825 168.077C353.11 167.378 354.695 166.196 355.582 165.416C354.238 166.921 352.707 168.776 353.029 169.152C353.486 169.636 357.302 167.647 359.694 164.852C363.833 160.014 363.242 153.296 362.838 150.554C363.806 149.291 365.069 147.517 366.359 145.26C367.542 143.244 370.955 136.956 372.433 128.409C375.04 113.279 369.692 101.346 367.542 96.6699C365.607 92.5043 362.328 85.5974 357.356 85.3018C356.711 85.2211 355.072 85.1405 354.024 86.0543Z",
  fill: "#908E8E"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.22,
  d: "M372.137 127.979C370.686 132.198 368.966 136.633 366.923 141.282C365.472 144.588 363.994 147.678 362.489 150.608C361.737 153.027 360.312 156.655 357.49 160.39C354.534 164.314 351.282 166.706 349.105 168.077C349.723 168.103 350.476 168.05 351.309 167.835C353.405 167.351 354.803 166.195 355.502 165.496C354.695 166.518 353.862 167.512 353.056 168.533C353.701 168.426 354.722 168.238 355.851 167.727C361.763 165.066 363 157.837 363.08 157.353C363.295 156.037 363.43 153.779 362.623 150.984C364.558 148.7 367.004 145.287 368.966 140.691C371.143 135.638 371.868 131.097 372.137 127.979Z",
  fill: "#908E8E"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M307.61 67.0797C303.283 72.0247 306.266 78.9315 306.669 79.8722C308.174 83.3659 312.071 88.3378 317.016 87.9347C320.618 87.6122 322.902 84.5753 323.466 83.769C327.444 78.0447 326.127 67.1065 319.408 64.2847C315.699 62.7259 310.593 63.6397 307.61 67.0797Z",
  fill: "#FA6918"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M318.522 71.4873C318.71 73.6105 320.94 74.0673 322.445 77.5611C323.52 80.0873 323.52 82.5598 323.332 84.3336C325.079 84.4948 328.304 84.5755 331.959 83.178C334.835 82.0761 336.85 80.4904 338.06 79.3886C337.495 78.1255 336.662 76.2711 335.668 74.0673C331.368 64.688 330.669 63.8817 329.621 63.4786C325.428 61.893 318.172 67.5367 318.522 71.4873Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M303.041 43.7255C302.128 45.0155 301.563 46.6011 301.483 53.4005C301.429 59.2055 301.751 64.4999 302.289 69.203C303.498 68.5042 304.708 67.8055 305.917 67.1067C306.455 68.4236 307.368 70.2242 308.927 71.9711C312.018 75.438 315.78 76.6205 317.446 77.0505C319.193 76.6205 323.547 75.2767 326.853 71.1649C329.029 68.4236 329.728 65.7092 329.889 65.0911C330.884 61.033 329.916 57.6736 329.406 56.2761C330.051 55.9805 331.045 55.4161 331.798 54.3949C333.383 52.2449 333.813 48.4017 331.851 47.1117C330.4 46.1442 327.82 46.7086 325.885 48.6974C325.455 47.703 324.783 46.3324 323.708 44.908C323.439 44.5586 321.424 41.9249 318.951 40.5542C314.195 37.813 306.32 39.103 303.041 43.7255Z",
  fill: "white",
  stroke: "#090707",
  strokeWidth: 0.5375,
  strokeMiterlimit: 10
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M301.081 52.1641C300.006 51.9759 298.017 51.4116 297.076 49.7722C295.464 47.0041 297.829 42.7847 298.42 41.7366C298.904 40.8497 300.194 38.7266 305.676 34.8834C309.842 31.9541 311.938 30.5028 314.195 29.8041C322.204 27.4122 329.541 31.5509 330.912 32.3303C333.787 33.9697 335.615 35.7434 337.066 37.1409C339.297 39.2909 341.796 41.7634 344.591 44.6122C351.767 53.9109 354.293 62.4034 355.314 67.4828C356.47 73.2341 357.652 79.0928 354.212 82.5328C350.772 85.9728 344.484 85.2741 340.64 83.6347C335.292 81.3503 333.008 76.5128 331.234 72.7772C328.224 66.3809 328.036 60.2534 328.332 56.2759C331.019 55.4966 332.39 52.9703 331.772 51.0622C331.288 49.5572 329.487 48.0522 327.633 48.5897C326.209 48.9928 325.187 50.4709 325.268 52.1909C323.978 52.1641 320.538 51.8684 317.259 49.3959C314.867 47.5953 313.658 45.4453 313.094 44.2628C311.615 44.4509 308.659 44.9884 305.676 47.1384C303.177 48.8584 301.779 50.9278 301.081 52.1641Z",
  fill: "#FA6918"
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.24,
  d: "M318.871 57.2974C322.096 61.1942 323.117 65.3061 323.117 65.3061C324.165 69.9286 322.66 73.8524 321.988 75.438C323.681 74.148 325.401 72.858 327.094 71.568C328.277 75.4917 329.433 79.3886 330.615 83.3124C331.502 83.2317 333.329 82.9092 335.157 81.6192C336.554 80.6249 337.388 79.4692 337.844 78.7436C335.668 76.728 331.502 72.2667 329.594 65.2524C328.68 61.8661 328.546 58.8561 328.653 56.5986C331.099 55.6042 332.362 53.2124 331.851 51.2236C331.475 49.7724 329.997 48.0255 328.089 48.2942C326.503 48.5361 325.186 50.0949 325.213 52.003C324.004 52.003 321.155 51.8686 318.172 50.068C315.081 48.2136 313.603 45.6336 313.039 44.5317C313.173 49.6917 314.759 52.6749 316.183 54.4486C317.124 55.658 317.554 55.7117 318.871 57.2974Z",
  fill: "#908E8E"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M306.374 56.1687C306.078 57.2437 306.105 58.3456 306.508 59.3937C306.643 59.77 307.153 59.7968 307.288 59.3937C307.61 58.4262 307.61 57.405 307.315 56.4375C307.153 55.9537 306.374 56.1418 306.535 56.6525C306.804 57.5125 306.777 58.3456 306.508 59.2056C306.777 59.2056 307.019 59.2056 307.288 59.2056C306.938 58.2918 306.885 57.3512 307.153 56.4106C307.288 55.8731 306.535 55.6581 306.374 56.1687Z",
  fill: "#090707"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M305.406 54.5025C306.105 54.0725 306.965 54.1531 307.556 54.7175C307.933 55.0669 308.497 54.5025 308.121 54.1531C307.288 53.3469 305.998 53.1856 305.003 53.8038C304.573 54.0725 304.976 54.7713 305.406 54.5025Z",
  fill: "#090707"
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  d: "M308.309 61.3287C308.82 61.3287 308.82 60.5225 308.309 60.5225C307.771 60.5225 307.771 61.3287 308.309 61.3287Z",
  fill: "#090707"
});

var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "M310.083 58.9905C310.083 59.0174 310.083 59.0443 310.083 59.0712C310.083 59.2862 310.271 59.4743 310.486 59.4743C310.701 59.4743 310.889 59.2862 310.889 59.0712C310.889 59.0443 310.889 59.0174 310.889 58.9905C310.889 58.7755 310.701 58.5874 310.486 58.5874C310.271 58.5874 310.083 58.7487 310.083 58.9905Z",
  fill: "#090707"
});

var _ref220 = /*#__PURE__*/React.createElement("path", {
  d: "M310.163 61.0064C310.674 61.0064 310.674 60.2002 310.163 60.2002C309.653 60.2002 309.653 61.0064 310.163 61.0064Z",
  fill: "#090707"
});

var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "M299.091 57.4053C298.768 58.4803 298.795 59.5821 299.171 60.6303C299.306 61.0065 299.816 61.0065 299.951 60.6303C300.273 59.6628 300.3 58.6415 300.031 57.674C299.897 57.1634 299.118 57.3784 299.252 57.889C299.494 58.749 299.467 59.5821 299.171 60.4153C299.44 60.4153 299.682 60.4153 299.951 60.4153C299.628 59.5015 299.575 58.5609 299.87 57.6203C300.005 57.1096 299.225 56.8946 299.091 57.4053Z",
  fill: "#090707"
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M298.634 55.3895C299.198 55.0939 299.978 55.2283 300.354 55.7658C300.65 56.1689 301.348 55.7658 301.053 55.3626C300.381 54.4758 299.225 54.1801 298.231 54.6908C297.774 54.9326 298.177 55.6314 298.634 55.3895Z",
  fill: "#090707"
});

var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "M307.691 70.0092C309.76 69.6329 311.561 68.531 312.904 66.8917C313.146 66.596 312.716 66.166 312.474 66.4617C311.211 68.0204 309.518 69.0417 307.529 69.4179C307.153 69.4985 307.314 70.0898 307.691 70.0092Z",
  fill: "#090707"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "M311.884 66.5159C312.367 66.6771 312.77 66.919 313.12 67.2684C313.389 67.5371 313.819 67.1071 313.55 66.8384C313.12 66.4084 312.609 66.1127 312.045 65.9246C311.669 65.8171 311.507 66.4084 311.884 66.5159Z",
  fill: "#090707"
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.45,
  d: "M328.626 31.3628C332.039 36.0928 336.42 42.7847 340.586 51.3309C344.993 60.3609 348.218 67.1603 345.719 69.8478C342.413 73.4222 330.991 67.7515 329.164 66.8109C329.54 69.2565 330.481 73.1534 333.249 77.0503C334.646 79.0122 337.092 82.479 341.607 84.0915C344.321 85.059 346.74 85.0053 347.681 84.9247C348.944 84.844 350.395 84.7365 351.981 83.8765C351.981 83.8765 354.05 82.7747 355.448 80.5172C357.571 77.0772 356.442 72.4278 354.937 66.5959C353.136 59.6084 350.718 54.959 348.353 50.3634C347.761 49.2347 347.063 47.9178 345.934 46.3859C344.805 44.8272 343.972 43.994 340.478 40.6347C335.291 35.609 334.485 34.8834 332.926 33.8353C331.206 32.6528 329.674 31.8734 328.626 31.3628Z",
  fill: "#FA6918"
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.43,
  d: "M322.15 77.0771C322.365 77.6953 322.848 79.4421 322.15 81.3771C321.102 84.2528 318.199 85.2203 317.742 85.3547C314.437 86.4297 310.271 84.7365 307.476 81.0547C307.852 82.0222 308.685 83.7422 310.405 85.2472C311.265 85.9997 313.603 88.0153 316.909 87.7734C317.473 87.7197 321.102 87.4509 322.768 84.3065C323.977 82.0759 323.708 79.2809 322.15 77.0771Z",
  fill: "#FA6918"
});

function SvgMeeting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 322,
    viewBox: "0 0 430 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/Meeting.2fc1f7d2.svg";
export { ForwardRef as ReactComponent };